// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3g0K3","right":"styles_right__11LQu"};